<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Selbstauskunft</p>
      <h2 class="presentation-page__title">Selbstauskunft — Kreditverpflichtungen</h2>
      <p class="presentation-page__text">
        Erfassung der laufenden Kredit- und Darlehensverpflichtungen für die Bonitätsprüfung.
      </p>
      <div class="presentation-page__form">
        <div class="presentation-page__form-header">Selbstauskunft — Kreditverpflichtungen</div>
        <div class="presentation-page__form-body">
          <section
            v-for="section in sections"
            :key="section.title"
            class="presentation-page__form-section"
          >
            <h3 class="presentation-page__form-section-title">{{ section.title }}</h3>
            <div class="presentation-page__form-fields">
              <div
                v-for="field in section.fields"
                :key="field.label"
                class="presentation-page__form-field"
              >
                <label class="presentation-page__form-field-label">{{ field.label }}</label>
                <div class="presentation-page__form-field-input" aria-hidden="true"></div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <p class="presentation-page__disclaimer">
        Vorlage zur Erfassung beim Erstgespräch — wird im RETIS-System digital strukturiert
        weitergeführt.
      </p>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage43',
  components: { PrintPageLandscape, PresentationPage },
  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  data() {
    return {
      sections: [
        {
          title: 'Immobilienkredite',
          fields: [
            { label: 'Bank' },
            { label: 'Ursprungsbetrag' },
            { label: 'Restschuld' },
            { label: 'Monatsrate' },
          ],
        },
        {
          title: 'Konsum- und Autokredite',
          fields: [
            { label: 'Bank' },
            { label: 'Betrag' },
            { label: 'Restschuld' },
            { label: 'Monatsrate' },
          ],
        },
        {
          title: 'Sonstige Verbindlichkeiten',
          fields: [
            { label: 'Art / Gläubiger' },
            { label: 'Betrag' },
            { label: 'Restschuld' },
            { label: 'Monatsrate' },
          ],
        },
      ],
    };
  },
};
</script>
